import React, { Component } from "react";
import { Link } from "react-router-dom";
class Category extends Component {
  state = {};
  render() {
    const style = { cursor: "pointer" };
    if (this.props.link === false) {
      if (this.props.allowSelection === true) {
        return (
          <div className="category cursor_btn " onClick={this.selectCategory}>
            <div className="category_row">
              <label className="hashtag hashtag_padding cursor_btn">#</label>
              <label className="category_name cursor_btn">
                {this.props.category.name}
              </label>
            </div>
          </div>
        );
      }
      return (
        <div className="category">
          <div className="category_row">
            <label className="hashtag">#</label>
            <label className="category_name">{this.props.category.name}</label>
          </div>
        </div>
      );
    }
    return (
      <Link style={style} to={"/category/" + this.props.category.id}>
        <div style={style} className="category">
          <div className="category_row">
            <label style={style} className="hashtag">
              #
            </label>
            <label style={style} className="category_name">
              {this.props.category.name}
            </label>
          </div>
        </div>
      </Link>
    );
  }

  selectCategory = e => {
    this.props.selectCategory(this.props.category);
  };
}

export default Category;



// WEBPACK FOOTER //
// ./src/components/categories/category.jsx